import { z } from 'zod';

import { OrderDirection } from '@/constants/orderDirection';

export const DormancyDetailTabKey = {
  ALERT: 'alert',
  EXCLUDED: 'excluded',
  SUSPEND_CANDIDATE: 'suspend_candidate',
} as const;

export type DormancyDetailTabKey =
  (typeof DormancyDetailTabKey)[keyof typeof DormancyDetailTabKey];

export const DormancyDetailTabKeySchema = z.enum([
  'alert',
  'excluded',
  'suspend_candidate',
]);

export const DormancyDetailColumnKey = {
  USER_NAME: 'userName',
  LAST_SIGNED_IN_AT: 'effectiveLastSignedInAt',
  DORMANT_DAYS: 'dormantDays',
  PATTERN: 'dormancyPattern',
  ACTIONS: 'actions',
} as const;

export type DormancyDetailColumnKey =
  (typeof DormancyDetailColumnKey)[keyof typeof DormancyDetailColumnKey];

export const DormancyDetailSearchSchema = z.object({
  tab: DormancyDetailTabKeySchema.default(DormancyDetailTabKey.ALERT),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  sortColumn: z.string().optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
  dormantDaysMin: z.number().optional(),
  dormantDaysMax: z.number().optional(),
  patternFilter: z
    .enum(['UNUSED', 'LOW_FREQUENCY', 'ON_LEAVE', 'ALUMNI', 'INVITED'])
    .optional(),
});

export type DormancyDetailSearchParams = z.infer<
  typeof DormancyDetailSearchSchema
>;
